import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { GET_WORK_ORDER_OPERATIONS } from 'lib/api/queries';
import { getApmActiveJobWooRefs } from 'lib/selectors/getApmActiveJobWooRefs';
import { provideFallbackForCycleTimeMs } from '../helpers';

/**
 * Open work order operations for the jobs on this machine's APM board, in
 * board order.
 */
const useApmActiveWorkOrderOps = ({ skip = false } = {}) => {
  const activeWooRefs = useSelector(getApmActiveJobWooRefs);
  const skipQuery = skip || activeWooRefs.length === 0;

  const { data, loading } = useQuery(GET_WORK_ORDER_OPERATIONS, {
    variables: {
      where: {
        workOrderOperationRef: { _in: activeWooRefs },
        closedDate: { _is_null: true },
      },
      limit: activeWooRefs.length,
    },
    skip: skipQuery,
    fetchPolicy: 'cache-and-network',
  });

  const apmActiveWorkOrderOps = useMemo(() => {
    if (skipQuery) {
      return [];
    }
    const byRef = new Map(
      (data?.erpWorkOrderOperations ?? []).map((op) => {
        return [String(op.workOrderOperationRef), op];
      })
    );
    const ordered = activeWooRefs
      .map((ref) => {
        return byRef.get(String(ref));
      })
      .filter(Boolean);
    return provideFallbackForCycleTimeMs(ordered);
  }, [data, activeWooRefs, skipQuery]);

  return {
    apmActiveWorkOrderOps,
    loading: !skipQuery && loading && !data,
  };
};

export default useApmActiveWorkOrderOps;
